// Kategori sayfası davranışı: filtre, sıralama, Load more, kademeli filtre, intro.
// Sonuçlar Section Rendering API ile yenilenir; URL her durumda gerçektir
// (paylaşılabilir, geri tuşu çalışır, JS yoksa formlar ve linkler normal çalışır).

const coll = document.querySelector("[data-wd-coll]");
if (coll) init();

function init() {
  const sectionId = coll.dataset.section;
  let controller = null;

  // Bir URL'in bu section'ını getirir
  async function fetchSection(url) {
    controller?.abort();
    controller = new AbortController();
    const u = new URL(url, location.origin);
    u.searchParams.set("section_id", sectionId);
    const res = await fetch(u, { signal: controller.signal });
    if (!res.ok) throw new Error(`section ${res.status}`);
    return new DOMParser().parseFromString(await res.text(), "text/html");
  }

  const toUrl = (form) => {
    const params = new URLSearchParams();
    for (const [k, v] of new FormData(form)) if (v !== "") params.append(k, v);
    const sort = document.querySelector("[data-wd-sort]")?.value;
    if (sort && !params.has("sort_by")) params.set("sort_by", sort);
    params.delete("page");
    return `${form.action}?${params}`;
  };

  // Section'ı yeniden çizer; odak ve rayın kaydırma konumu korunur
  async function navigate(url, { push = true } = {}) {
    const root = document.querySelector("[data-wd-coll]");
    const focusId = document.activeElement?.id;
    const railScroll = root.querySelector(".wd-coll__rail")?.scrollTop ?? 0;
    root.classList.add("is-loading");
    try {
      const doc = await fetchSection(url);
      const fresh = doc.querySelector("[data-wd-coll]");
      const freshSheet = doc.getElementById("WdFilterSheet");
      root.replaceWith(fresh);
      const sheet = document.getElementById("WdFilterSheet");
      if (freshSheet && sheet) {
        const wasOpen = sheet.open;
        sheet.close?.();
        sheet.replaceWith(freshSheet);
        if (wasOpen) document.documentElement.classList.remove("wd-lock");
      }
      if (push) history.pushState({ wdColl: true }, "", url);
      const rail = fresh.querySelector(".wd-coll__rail");
      if (rail) rail.scrollTop = railScroll;
      if (focusId) document.getElementById(focusId)?.focus({ preventScroll: true });
      bind();
    } catch (err) {
      if (err.name !== "AbortError") location.href = url;
    }
  }

  function bind() {
    const root = document.querySelector("[data-wd-coll]");

    // Masaüstü rayı: her değişiklik anında uygulanır
    const rail = root.querySelector('[data-wd-filter-form="rail"]');
    rail?.addEventListener("change", () => navigate(toUrl(rail)));
    rail?.addEventListener("submit", (e) => {
      e.preventDefault();
      navigate(toUrl(rail));
    });

    // Sıralama (mobil çubuk ve desktop araç satırı)
    root.querySelectorAll("[data-wd-sort]").forEach((select) =>
      select.addEventListener("change", () => {
        const u = new URL(location.href);
        u.searchParams.set("sort_by", select.value);
        u.searchParams.delete("page");
        navigate(u.toString());
      })
    );

    // Çip kaldırma, Clear all: link, ama sayfa yenilenmeden
    document.querySelectorAll("[data-wd-nav]").forEach((a) =>
      a.addEventListener("click", (e) => {
        e.preventDefault();
        navigate(a.href);
      })
    );

    // Rayda "Show all (N)"
    root.querySelectorAll("[data-wd-show-all]").forEach((button) =>
      button.addEventListener("click", () => {
        button.closest("[data-wd-filter]").querySelectorAll(".is-overflow").forEach((el) => (el.hidden = false));
        button.remove();
      })
    );

    // Load more: sonraki sayfanın kartlarını ekler, URL gerçek ?page= olur
    const more = root.querySelector("[data-wd-load-more]");
    more?.addEventListener("click", async (e) => {
      e.preventDefault();
      if (more.classList.contains("is-loading")) return;
      more.classList.add("is-loading");
      try {
        const doc = await fetchSection(more.href);
        const cards = doc.querySelectorAll("[data-wd-grid] > *");
        root.querySelector("[data-wd-grid]").append(...cards);
        const showing = root.querySelector("[data-wd-showing]");
        const count = root.querySelectorAll("[data-wd-grid] > *").length;
        showing.textContent = showing.dataset.template.replace("%shown", count);
        history.replaceState(history.state, "", more.href);
        const next = doc.querySelector("[data-wd-load-more]");
        if (next) more.href = next.href;
        else more.remove();
      } catch {
        location.href = more.href;
      } finally {
        more.classList.remove("is-loading");
      }
    });

    // Intro: yalnız taşıyorsa "Read more", açılınca "Read less". Kapanınca metin kısalır:
    // intro'nun başı header'ın altında kaldıysa oraya dönülür (okuyan yerini kaybetmesin)
    const intro = document.querySelector("[data-wd-intro]");
    const toggle = intro?.querySelector("[data-wd-intro-toggle]");
    if (intro && toggle) {
      const text = intro.querySelector(".wd-coll-head__intro-text");
      toggle.hidden = text.scrollHeight <= text.clientHeight + 1;
      intro.classList.toggle("is-clamped", !toggle.hidden);
      toggle.onclick = () => {
        const open = !intro.classList.contains("is-open");
        intro.classList.toggle("is-open", open);
        toggle.setAttribute("aria-expanded", String(open));
        toggle.textContent = open ? toggle.dataset.less : toggle.dataset.more;
        const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--header-offset")) || 0;
        if (!open && intro.getBoundingClientRect().top < header) intro.scrollIntoView({ block: "start" });
      };
    }

    bindSheet();
  }

  // Mobil sheet: seçim sayıyı günceller, "Show N designs" uygular
  function bindSheet() {
    const sheet = document.getElementById("WdFilterSheet");
    const form = sheet?.querySelector('[data-wd-filter-form="sheet"]');
    const apply = sheet?.querySelector("[data-wd-apply]");
    if (!form || !apply) return;
    const label = apply.querySelector("[data-wd-apply-label]");
    let pending = null;

    form.addEventListener("change", async () => {
      apply.classList.add("is-loading");
      const url = toUrl(form);
      pending = url;
      try {
        const doc = await fetchSection(url);
        if (pending !== url) return;
        const count = Number(doc.querySelector("[data-wd-coll]")?.dataset.count ?? NaN);
        if (Number.isFinite(count)) {
          label.textContent = count === 1 ? apply.dataset.labelOne : apply.dataset.labelOther.replace("%count", count);
        }
      } catch {} finally {
        apply.classList.remove("is-loading");
      }
    });
    apply.addEventListener("click", () => {
      sheet.close();
      navigate(toUrl(form));
    });

    cascade(form);
  }

  // Kademeli filtre: uzun taksonomi listeleri önce gruplarıyla (Master Brief §15.3)
  let indexPromise = null;
  const loadIndex = () => (indexPromise ||= fetch(coll.dataset.index).then((r) => r.json()).catch(() => ({})));

  async function cascade(form) {
    const long = [...form.querySelectorAll("[data-wd-filter]")].filter((f) => Number(f.dataset.count) > 12 && f.dataset.tax);
    if (!long.length) return;
    const index = await loadIndex();
    const backLabel = document.querySelector("[data-wd-coll]").dataset.back;

    for (const fieldset of long) {
      const map = index[fieldset.dataset.tax];
      if (!map) continue;
      const values = fieldset.querySelector("[data-wd-filter-values]");
      const labels = [...values.children];
      const groups = new Map();
      for (const el of labels) {
        const group = map[el.dataset.label] || el.dataset.label;
        if (!groups.has(group)) groups.set(group, []);
        groups.get(group).push(el);
      }
      if (groups.size < 2) continue;

      const list = document.createElement("div");
      list.className = "wd-filter__groups";
      const back = document.createElement("button");
      back.type = "button";
      back.className = "wd-filter__back";
      back.textContent = `← ${backLabel}`;
      back.hidden = true;

      const showGroups = () => {
        labels.forEach((el) => (el.hidden = true));
        list.hidden = false;
        back.hidden = true;
      };
      for (const [name, els] of groups) {
        const selected = els.filter((el) => el.querySelector("input").checked).length;
        const row = document.createElement("button");
        row.type = "button";
        row.className = "wd-filter__group";
        row.innerHTML = `<span></span><span class="wd-filter__group-count"></span>`;
        row.firstChild.textContent = name;
        row.lastChild.textContent = selected ? `${selected} / ${els.length}` : String(els.length);
        row.addEventListener("click", () => {
          labels.forEach((el) => (el.hidden = !els.includes(el)));
          list.hidden = true;
          back.hidden = false;
          back.focus();
        });
        list.append(row);
      }
      back.addEventListener("click", showGroups);
      values.before(back, list);
      showGroups();
    }
  }

  window.addEventListener("popstate", () => navigate(location.href, { push: false }));
  bind();
}
